import { render, staticRenderFns } from "./PromocionalCodeForm.vue?vue&type=template&id=2f8dccca&scoped=true"
import script from "./PromocionalCodeForm.vue?vue&type=script&lang=js"
export * from "./PromocionalCodeForm.vue?vue&type=script&lang=js"
import style0 from "./PromocionalCodeForm.vue?vue&type=style&index=0&id=2f8dccca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8dccca",
  null
  
)

export default component.exports